import BrButton from '@govbr/react-components/lib/BrButton';
import { Dialog, DialogContent } from '@material-ui/core';
import styles from './ModalNaoIncluir.module.css';

interface Props {
  open: boolean;
  onContinuar: () => void;
  onNaoIncluir: () => void;
  nomeIntegrante?: string;
  variante?: 'aviso' | 'perguntas';
  loadingNaoIncluir?: boolean;
}

const TEXTOS = {
  aviso: {
    descricao: 'Caso não confirme a inclusão, o Responsável Familiar (RF) deverá comparecer ao CRAS para atualização cadastral.',
    pergunta: (nome: string) => `Tem certeza que não quer incluir ${nome} no cadastro da sua família?`,
    linkAcao: 'Não quero incluir',
  },
  perguntas: {
    descricao: 'Caso cancele, a inclusão não será confirmada e o Responsável Familiar (RF) deverá comparecer ao CRAS para atualização cadastral.',
    pergunta: (nome: string) => `Tem certeza que deseja cancelar a inclusão de ${nome} no cadastro da sua família?`,
    linkAcao: 'Sim, quero cancelar',
  },
};

const ModalNaoIncluir: React.FC<Props> = ({ open, onContinuar, onNaoIncluir, nomeIntegrante, variante = 'aviso', loadingNaoIncluir = false }) => {
  const textos = TEXTOS[variante];
  const nome = nomeIntegrante ?? 'este integrante';

  return (
    <Dialog open={open} onClose={onContinuar} maxWidth="xs" fullWidth>
      <DialogContent className={styles.modalContent}>
        <p className={styles.modalTexto}>{textos.descricao}</p>
        <p className={styles.modalPergunta}>{textos.pergunta(nome)}</p>
        <BrButton className={styles.modalBotaoSim} onClick={onContinuar}>
          Quero continuar a inclusão
        </BrButton>
        <button className={styles.modalLinkNao} onClick={onNaoIncluir} disabled={loadingNaoIncluir}>
          {loadingNaoIncluir ? <div className="loading small"></div> : textos.linkAcao}
        </button>
      </DialogContent>
    </Dialog>
  );
};

export default ModalNaoIncluir;
